export const repairShopFieldConfiguration = [
  {
    name: "shopName",
    label: "Shop Name",
    type: "text",
    validation: {
      required: "Shop name is required",
      minLength: {
        value: 2,
        message: "Shop name must be at least 2 characters long",
      },
      maxLength: {
        value: 50,
        message: "Shop name must not exceed 50 characters",
      },
    },
  },
  {
    name: "streetAddress",
    label: "Street Address",
    type: "text",
    validation: {
      required: "Street address is required",
      minLength: {
        value: 5,
        message: "Street address must be at least 5 characters long",
      },
      maxLength: {
        value: 150,
        message: "Street address must not exceed 150 characters",
      },
    },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
    validation: {
      required: "Phone number is required",
    },
  },
];

export const repairShopInitialValues = {
  shopName: "",
  streetAddress: "",
  phoneNumber: "",
};
